import { Link } from 'react-router-dom';

import Button from '../components/ui/Button';
import Card from '../components/ui/Card';
import Marquee from '../components/ui/Marquee';
import Reveal from '../components/ui/Reveal';
import { Section, SectionHeading } from '../components/ui/Section';
import { FREE_TRIAL_MESSAGE, SITE, whatsappLink } from '../config/site';
import ChannelStrip from './channel';
import SeasonBanner from '../components/SeasonBanner';

import tvLogo from '../assets/tv.png';

import img1 from '../assets/poster/1666.webp';
import img2 from '../assets/poster/2666.webp';
import img3 from '../assets/poster/3666.webp';
import img4 from '../assets/poster/4666.webp';
import img5 from '../assets/poster/5666.webp';
import img6 from '../assets/poster/6666.webp';
import img7 from '../assets/poster/7666.webp';
import img8 from '../assets/poster/8666.webp';
import img9 from '../assets/poster/9666.webp';
import img10 from '../assets/poster/10666.webp';
import img11 from '../assets/poster/des_enchantees.jpg';
import img12 from '../assets/poster/erica.jpg';
import img13 from '../assets/poster/game of thrones.jpg';
import img14 from '../assets/poster/high potential.jpg';
import img15 from '../assets/poster/mobland.jpg';
import img16 from '../assets/poster/reacher.jpg';
import img17 from '../assets/poster/surface.jpg';
import img18 from '../assets/poster/tierra_de_mujeres.jpg';
import img19 from '../assets/poster/un_si_grand_soleil.jpg';
import img20 from '../assets/poster/valide.jpg';

const CATALOGUE = [
    { image: img1, title: 'French Lover', category: 'Romance' },
    { image: img2, title: 'La Voisine Idéale', category: 'Documentaire' },
    { image: img3, title: 'Moi, moche et méchant 4', category: 'Animation' },
    { image: img4, title: 'Black Adam', category: 'Action' },
    { image: img5, title: 'Sans un bruit 2', category: 'Horreur' },
    { image: img6, title: 'À bras ouverts', category: 'Comédie' },
    { image: img7, title: 'KPop Demon Hunters', category: 'Animation' },
    { image: img8, title: 'La Disparue de la cabine 10', category: 'Drame' },
    { image: img9, title: 'Caramelo', category: 'Comédie' },
    { image: img10, title: 'Furioza 2', category: 'Action' },
    { image: img11, title: 'Des Enchantées', category: 'Fantastique' },
    { image: img12, title: 'Erica', category: 'Thriller' },
    { image: img13, title: 'Game of Thrones', category: 'Fantastique' },
    { image: img14, title: 'High Potential', category: 'Drame' },
    { image: img15, title: 'MobLand', category: 'Action' },
    { image: img16, title: 'Reacher', category: 'Action' },
    { image: img17, title: 'Surface', category: 'Thriller' },
    { image: img18, title: 'Tierra de Mujeres', category: 'Drame' },
    { image: img19, title: 'Un si grand soleil', category: 'Série' },
    { image: img20, title: 'Validé', category: 'Drame' },
];

/* Reassurance points — each one restates a commitment made elsewhere on the
   page (delivery window, guarantee, payment methods, support hours) rather
   than an unverifiable statistic. */
const TRUST_POINTS = [
    { label: 'Accès sous 5–15 min', icon: 'clock' },
    { label: 'Paiement sécurisé', icon: 'shield' },
    { label: 'Garantie 15 jours', icon: 'check' },
    { label: 'Support 7j/7', icon: 'chat' },
];

const ICONS = {
    clock: 'M12 7v5l3 2m6-2a9 9 0 11-18 0 9 9 0 0118 0z',
    shield: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
    check: 'M5 13l4 4L19 7',
    chat: 'M21 12a8 8 0 01-8 8H7l-4 3V12a8 8 0 018-8h2a8 8 0 018 8z',
};

const FEATURES = [
    {
        title: '79 000+ chaînes en direct',
        body: "Toutes les chaînes françaises, belges, européennes et internationales, plus les grands bouquets sport et cinéma. Compatible avec IPTV Smarters, TiviMate et les listes M3U.",
        icon: 'M4 7h16a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V8a1 1 0 011-1zM8 3l4 4 4-4',
    },
    {
        title: 'Serveurs stables et rapides',
        body: "Une infrastructure dédiée avec un zapping quasi instantané et une lecture continue, y compris pendant les matchs et les pics d'audience du soir.",
        icon: 'M13 10V3L4 14h7v7l9-11h-7z',
    },
    {
        title: 'Installation en quelques minutes',
        body: "Vos codes Xtream et votre lien M3U arrivent par email juste après le paiement, avec un guide pas à pas pour Smart TV, boîtier Android, Fire Stick ou PC.",
        icon: 'M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 11-4 0v-.09A1.65 1.65 0 008 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H2a2 2 0 110-4h.09A1.65 1.65 0 004.6 8a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06A1.65 1.65 0 009 3.6 1.65 1.65 0 0010 2.09V2a2 2 0 114 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06A1.65 1.65 0 0019.4 8V9a1.65 1.65 0 001.51 1H21a2 2 0 110 4h-.09a1.65 1.65 0 00-1.51 1z',
    },
];

export default function Home() {
    return (
        <>
            {/* ---------------------------------------------------------- Hero */}
            <section className="relative overflow-hidden pt-14 pb-20 md:pt-20 md:pb-28">
                {/* Ambient backdrop. Purely decorative, so it is hidden from AT
                    and never intercepts pointer events. */}
                <div className="pointer-events-none absolute inset-0 -z-10" aria-hidden="true">
                    <div className="absolute left-1/2 top-[-18rem] h-[36rem] w-[36rem] -translate-x-1/2 rounded-full bg-brand/[0.07] blur-[130px]" />
                    <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-line-strong to-transparent" />
                </div>

                <div className="container text-center">
                    <Reveal>
                        <span className="inline-flex items-center gap-2 rounded-full border border-line-brand bg-brand/[0.08] px-4 py-1.5 text-xs font-bold uppercase tracking-[0.14em] text-brand">
                            <span className="h-1.5 w-1.5 rounded-full bg-brand" aria-hidden="true" />
                            IPTV Premium · France &amp; Belgique
                        </span>
                    </Reveal>

                    <Reveal delay={80}>
                        <h1 className="mx-auto mt-6 max-w-4xl text-display-lg font-extrabold text-white text-balance">
                            Toute la télé, le sport et le cinéma
                            <span className="mt-1 flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
                                <span>réunis dans</span>
                                <span className="inline-flex items-center gap-2">
                                    <img
                                        src={tvLogo}
                                        alt=""
                                        aria-hidden="true"
                                        width="64"
                                        height="64"
                                        className="h-[0.9em] w-auto"
                                    />
                                    <span className="text-brand">{SITE.name}</span>
                                </span>
                            </span>
                        </h1>
                    </Reveal>

                    <Reveal delay={140}>
                        <p className="mx-auto mt-6 max-w-2xl text-lead text-content-muted text-pretty">
                            Plus de 79 000 chaînes en direct et 249 000 films et séries en 4K, sur votre
                            Smart TV, votre boîtier Android, votre Fire Stick ou votre PC. Activation
                            immédiate, sans engagement.
                        </p>
                    </Reveal>

                    <Reveal delay={200}>
                        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
                            <Button as={Link} to="/#forfaits" size="lg" className="w-full sm:w-auto">
                                Voir les forfaits
                                <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </Button>
                            <Button
                                href={whatsappLink(FREE_TRIAL_MESSAGE)}
                                target="_blank"
                                rel="noopener noreferrer"
                                variant="outline"
                                size="lg"
                                className="w-full sm:w-auto"
                            >
                                Demander un test gratuit
                            </Button>
                        </div>
                    </Reveal>

                    <Reveal delay={260}>
                        <ul className="mx-auto mt-10 flex max-w-3xl flex-wrap items-center justify-center gap-x-6 gap-y-3">
                            {TRUST_POINTS.map((point) => (
                                <li key={point.label} className="flex items-center gap-2 text-sm text-content-muted">
                                    <svg
                                        className="h-4 w-4 shrink-0 text-brand"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        aria-hidden="true"
                                    >
                                        <path d={ICONS[point.icon]} />
                                    </svg>
                                    {point.label}
                                </li>
                            ))}
                        </ul>
                    </Reveal>
                </div>

                {/* Catalogue preview. A CSS marquee rather than a JS carousel:
                    no timers, no re-renders, and it pauses on hover. */}
                <Reveal delay={320} className="mt-16">
                    <Marquee
                        items={CATALOGUE}
                        duration={70}
                        gap="gap-4"
                        aria-label="Aperçu du catalogue de films et séries"
                        renderItem={(item) => (
                            <figure className="group relative h-52 w-36 overflow-hidden rounded-xl border border-line sm:h-64 sm:w-44">
                                <img
                                    src={item.image}
                                    alt={item.title}
                                    loading="lazy"
                                    decoding="async"
                                    className="h-full w-full object-cover transition-transform duration-500 ease-smooth group-hover:scale-105"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-950/20 to-transparent" />
                                <figcaption className="absolute inset-x-0 bottom-0 p-3">
                                    <span className="block text-[0.6875rem] font-bold uppercase tracking-wider text-brand">
                                        {item.category}
                                    </span>
                                    <span className="mt-0.5 block truncate text-sm font-semibold text-white">
                                        {item.title}
                                    </span>
                                </figcaption>
                            </figure>
                        )}
                    />
                </Reveal>
            </section>

            {/* -------------------------------------------- Season promotion */}
            <div className="container mt-16 md:mt-20">
                <Reveal>
                    <SeasonBanner />
                </Reveal>
            </div>

            {/* ------------------------------------------------------ Channels */}
            <ChannelStrip />

            {/* ------------------------------------------------------ Features */}
            <Section>
                <SectionHeading
                    eyebrow={`Pourquoi ${SITE.name}`}
                    title="Un service pensé pour être simple et fiable"
                    description="Trois engagements qui font la différence au quotidien, du paiement jusqu'à la première soirée devant votre écran."
                />

                <div className="grid gap-5 md:grid-cols-3">
                    {FEATURES.map((feature, index) => (
                        <Reveal key={feature.title} delay={index * 90}>
                            <Card interactive className="h-full p-7">
                                <span className="mb-6 grid h-12 w-12 place-items-center rounded-xl bg-brand text-ink-950">
                                    <svg
                                        className="h-6 w-6"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        aria-hidden="true"
                                    >
                                        <path d={feature.icon} />
                                    </svg>
                                </span>
                                <h3 className="text-title font-bold text-white">{feature.title}</h3>
                                <p className="mt-3 leading-relaxed text-content-muted text-pretty">
                                    {feature.body}
                                </p>
                            </Card>
                        </Reveal>
                    ))}
                </div>
            </Section>
        </>
    );
}
